import { fixedUi } from '@/i18n/fixedUi';
import { useCallback } from 'react';
import { resolveWriteShopId } from '@/hooks/usePlatformShopPick';
import { showToast } from '@/utils/toast';

/**
 * 模板库写操作选店：全部视图弹窗；官方模板复制时按类目筛店。
 */
export default function useSheinTemplateWriteShop({
  listAllShops = false,
  pageShopScope = '',
  listShopId = '',
  pickShop,
  isOfficialTab = false,
  shopsForOfficialTemplate,
  shopsForOfficialTemplates,
} = {}) {
  const ensureWriteShopId = useCallback(async ({
    title = '选择店铺',
    description = '全部视图下请选择一家店铺后再继续。',
    confirmText = '确认',
    shops,
  } = {}) => resolveWriteShopId({
    listAllShops,
    pageShopScope,
    listShopId,
    pickShop,
    title,
    description,
    confirmText,
    shops,
  }), [listAllShops, pageShopScope, listShopId, pickShop]);

  const ensureCopyShopId = useCallback(async (rows, {
    title = '选择复制到的店铺',
    description,
    confirmText = '复制到此店',
  } = {}) => {
    const templates = Array.isArray(rows) ? rows.filter(Boolean) : (rows ? [rows] : []);
    let eligibleShops;
    if (isOfficialTab && listAllShops && templates.length) {
      eligibleShops = templates.length > 1
        ? shopsForOfficialTemplates?.(templates)
        : shopsForOfficialTemplate?.(templates[0]);
      if (!eligibleShops?.length) {
        showToast(fixedUi("没有拥有该类目的店铺，无法复制"), 'warning');
        return null;
      }
    }
    const writeShopId = await ensureWriteShopId({
      title,
      description: description || (
        isOfficialTab && listAllShops
          ? '请选择拥有该类目的目标店铺，模板将复制到该店。'
          : '全部视图下请选择目标店铺，模板将复制到该店。'
      ),
      confirmText,
      ...(eligibleShops?.length ? { shops: eligibleShops } : {}),
    });
    if (!writeShopId) {
      showToast(fixedUi("请先选择店铺"), 'warning');
    }
    return writeShopId;
  }, [
    isOfficialTab,
    listAllShops,
    shopsForOfficialTemplate,
    shopsForOfficialTemplates,
    ensureWriteShopId,
  ]);

  return { ensureWriteShopId, ensureCopyShopId };
}
